import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { actions as accountActions } from '../../reducers/Account';
import { actions as loginActions } from '../../reducers/login';
import {
  accountSelector,
  isLoadingAccountSelector,
} from '../../selectors/Account';
import { setDestIfNeeded } from '@utils/intendedDest';

/**
 * This component primarily exists so that we can cache the intended_dest state in local storage
 * so that if we are not logged in, after the user logs in they will be able to continue their
 * Oauth Authorization step.
 */
class LoginAuthorize extends Component {
  state = {
    fetching: true,
  };

  componentDidMount() {
    const { fetchAccount } = this.props;

    fetchAccount();
  }

  componentDidUpdate(prevProps) {
    const { isLoading } = this.props;
    if (!isLoading && prevProps.isLoading) {
      this.setState({ fetching: false });
    }
  }

  render = () => {
    const { user } = this.props;
    const { fetching } = this.state;

    if (!user && fetching) {
      // waiting on user to load
      return null;
    }

    if (!user || !user.email_verified || !user.terms_accepted) {
      // if we finished loaded the account with an error, or the email is not yet verified/terms accepted,
      // then lets save the intended_dest and redirect them to dash to continue their flow.
      setDestIfNeeded();

      return <Redirect to="/dash" />;
    }

    // redirect to the web-backend authorize API with the same query parameters
    window.location = '/auth/authorize' + window.location.search;

    return null;
  };
}

LoginAuthorize.propTypes = {
  fetchAccount: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  user: PropTypes.object,
};

function mapStateToProps(state) {
  const account = accountSelector(state);
  const isLoading = isLoadingAccountSelector(state);

  return {
    isLoading,
    user: account.user,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...accountActions, ...loginActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginAuthorize);
